/**
 * @generated SignedSource<<facacf38b0339771d73a2993a2640d5e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GroupFormFields_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RolePicker_roles" | "ScopePicker_scopes">;
  readonly " $fragmentType": "GroupFormFields_query";
};
export type GroupFormFields_query$key = {
  readonly " $data"?: GroupFormFields_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"GroupFormFields_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GroupFormFields_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RolePicker_roles"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ScopePicker_scopes"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "ed0a222e997bf05ddb1ff11b1d7300ee";

export default node;
